import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class ExactProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async getStatus(): Promise<ExactStatusDTO> {
        const url = this.configurationService.APIURL + '/api/exact/status';
        let params = new HttpParams();
        return await this.http.get<ExactStatusDTO>(url, { params: params }).toPromise();
    }

    async getDataMapping(): Promise<ExactDataMappingDTO> {
        const url = this.configurationService.APIURL + '/api/exact/data-mapping';
        let params = new HttpParams();
        return await this.http.get<ExactDataMappingDTO>(url, { params: params }).toPromise();
    }

    async disconnect(): Promise<any> {
        const url = this.configurationService.APIURL + '/api/exact/disconnect';
        return await this.http.post(url, {}).toPromise();
    }
}

export interface ExactStatusDTO {
    isConnected: boolean;
    email: string;
    division: number;
    redirectUrl: string;
}

export interface ExactDataMappingDTO {
    journalMappings: JournalMapping[];
    testMappings: TestMapping[];
}

export interface JournalMapping {
    exactJournalCode: string;
    countryCode: string;
    isMapped: boolean;
}

export interface TestMapping {
    test: TestDTO;
    exactSearchCode: string;
    isMapped: boolean;
}

export interface TestDTO {
    reference: string;
    name: string;
    primaryColorHex: string;
    secondaryColorHex: string;
}
